/**
 * The function adjusts the Slick carousel based on the window width and a specified breakpoint.
 * @param carousel - The `carousel` parameter is the selector of the elements wrapper
 * @param options - Slick carousel options
 * @param [breakpoint=800] - The `breakpoint` determines at what viewport width the carousel will be destroyed
 */
function handleSlickForMobile(carousel, options, breakpoint = 800) {
  // console.log(carousel, options)
  var width = $(window).width();
  if (width >= breakpoint && carousel.hasClass('slick-slider')) {
    carousel.slick('unslick');
  } else if (width < breakpoint && !carousel.hasClass('slick-slider')) {
    carousel.slick(options);
  }
}


$(document).ready(function(){
  const Example = $('.example-section'); 
  const ExampleOptions = {
    infinite: true,
    dots: true, 
    arrows: false, 
    slidesToShow: 1,
    slidesToScroll: 1
  }; 
  handleSlickForMobile(Example, ExampleOptions, 1024);
  $(window).resize(function () {
    handleSlickForMobile(Example, ExampleOptions, 1024);
  });
 


  $('.ScrollToProduct').on('click', function (e) {
    e.preventDefault();
    const offsetTop = $('#product-main').offset().top - 120;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 500);
  });
  
  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});